<template>
  <div id="top-up-activation-summary">
    <slot name="txtBefore"></slot>
    <ShowSingle :topUpInfo="singleTopUpAmount" v-if="hasSingleTopUp">
      <template v-for="slot in possibleChildSlotsFor('Single')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowSingle>
    <ShowMonthly :topUpInfo="topUp" v-if="topUpAutoMonthly">
      <template v-for="slot in possibleChildSlotsFor('Monthly')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowMonthly>
    <ShowByLimit :topUpInfo="topUp" v-if="topUpAutoByLimit">
      <template v-for="slot in possibleChildSlotsFor('Limit')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowByLimit>
    <ShowWithoutAuto :topUpInfo="topUp" v-if="withoutTopUp">
      <template v-for="slot in possibleChildSlotsFor('Without')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ShowWithoutAuto>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ShowMonthly from '@/components/process/LIDL/Activation/TopUp/ShowMonthly.vue'
import ShowByLimit from '@/components/process/LIDL/Activation/TopUp/ShowByLimit.vue'
import ShowSingle from '@/components/process/LIDL/Activation/TopUp/ShowSingle.vue'
import ShowWithoutAuto from '@/components/process/LIDL/Activation/TopUp/ShowWithoutAuto.vue'
import slotProxy from '@/mixins/slotProxy'

export default {
  name: 'ShowTopUpData',
  computed: {
    ...mapGetters('activation/topUp', [
      'topUp',
      'hasSingleTopUp',
      'singleTopUpAmount',
      'withoutTopUp',
      'topUpAutoByLimit',
      'topUpAutoMonthly'
    ])
  },
  mixins: [
    slotProxy()
  ],
  components: {
    ShowSingle,
    ShowWithoutAuto,
    ShowMonthly,
    ShowByLimit
  }
}
</script>
